import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const AutomaticResponsesService = {

    getMessages: (account: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/get-messages-aut/${account}`);
    },
       
    updateWelcomeMessage: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/update-messages-aut/welcome`,  data );
    },
    setStatusWelcomeMessage: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/change-status-messages-aut/welcome`, data);
    },
       
    updateGoodbyeMessage: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/update-messages-aut/bye`,  data );
    },
    setStatusGoodbyeMessage: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/change-status-messages-aut/bye`, data);
    },
       
    updateOutHoursMessage: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/update-messages-aut/outtime`,  data );
    },
    setStatusOutHoursMessage: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/change-status-messages-aut/outtime`, data);
    },
       
    updateDayOffMessage: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/update-messages-aut/busday`,  data );
    },
    setStatusDayOffMessage: (data: any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/change-status-messages-aut/busday`, data);
    },
       
}